import { gql } from "apollo-boost";

export const CREATE_SHOP_COMMISION_INFLUENCER = gql`
  mutation CreateShopSettingCommissionInfulancer(
    $data: ShopSettingCommissionInfulancerInput!
  ) {
    createShopSettingCommissionInfulancer(data: $data) {
      id
    }
  }
`;

export const UPDATE_COMMISION_INFLUENCER = gql`
  mutation UpdateShopSettingCommissionInfulancer(
    $data: ShopSettingCommissionInfulancerInput!
    $where: ShopSettingCommissionInfulancerWhereInputOne!
  ) {
    updateShopSettingCommissionInfulancer(data: $data, where: $where) {
      id
    }
  }
`;
